import { render, staticRenderFns } from "./CommercialStrataOfficeSuite.vue?vue&type=template&id=1295a984&scoped=true&"
import script from "./CommercialStrataOfficeSuite.vue?vue&type=script&lang=ts&"
export * from "./CommercialStrataOfficeSuite.vue?vue&type=script&lang=ts&"
import style0 from "./CommercialStrataOfficeSuite.vue?vue&type=style&index=0&id=1295a984&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1295a984",
  null
  
)

export default component.exports